import { Component, OnInit, ViewChild } from "@angular/core";
import {
  TreeComponent,
  IActionMapping,
  ITreeOptions,
  TREE_ACTIONS,
  KEYS,
} from "angular-tree-component";

import { LaborGuideItem } from "../labor-guide-item";
import { LaborService } from "../labor.service";
import { MatDialog, MatMenuTrigger } from "@angular/material";
import { LabordialogComponent } from "../labordialog/labordialog.component";
import { NeededPartItem } from "../neededpartitem";
import { LaborsearchComponent } from "../laborsearch/laborsearch.component";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { LabordetailComponent } from "../labordetail/labordetail.component";
import { DetectchangeComponent } from "../detectchange/detectchange.component";
import { CopyComponent } from "../copy/copy.component";
import { connectableObservableDescriptor } from "rxjs/internal/observable/ConnectableObservable";

@Component({
  selector: "app-labor",
  templateUrl: "./labor.component.html",
  styleUrls: ["./labor.component.css"],
})
export class LaborComponent implements OnInit {
  @ViewChild(TreeComponent)
  private tree: TreeComponent;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @ViewChild("laborDetail") laborDetail: LabordetailComponent;
  isAdmin = false;
  cats = [];
  isDisplayedDetail = false;
  laborItems: LaborGuideItem[];
  neededPartItems: NeededPartItem[] = [];
  rootLevel: LaborGuideItem[];
  selectedNode: any;
  nodes = [];
  laborId = 0;
  laborType = "category";
  quantities: string[] = ["1", "2", "3", "4", "5", "Specification"];
  action = "";
  parentName = "";
  isLoading: boolean = false;
  isAddonMode = false;
  vinNumber = "";
  unverifiedLaborQty = 0;
  selectedCopiedTerminal: LaborGuideItem[] = [];

  actionMapping: IActionMapping = {
    // mouse: {
    //   click: TREE_ACTIONS.TOGGLE_ACTIVE_MULTI
    // }
    mouse: {
      click: (tree, node, $event) => {
        if ($event.shiftKey && node.data.item.Type == "Terminal") {
          let index = this.selectedCopiedTerminal.indexOf(node.data.item);
          if (index > -1) {
            this.selectedCopiedTerminal.splice(index, 1);
          } else {
            this.selectedCopiedTerminal.push(node.data.item);
          }
          console.log(this.selectedCopiedTerminal);
          // console.log(this.tree.treeModel.selectedLeafNodeIds);
          TREE_ACTIONS.TOGGLE_ACTIVE_MULTI(tree, node, $event);
        } else if (this.laborDetail.detectChange()) {
          console.log("detect change");
          const dialogRef = this.dialog.open(DetectchangeComponent);
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.laborDetail.save();
              node.setIsActive(true);
              this.selectedNode = node;
              this.isDisplayedDetail = false;
              // load neededpart if click on Terminal
              if (this.selectedNode.data.item.Type == "Terminal") {
                this.laborId = 0;
                this.laborType = "terminal";
                this.parentName = this.selectedNode.data.item.Title;
              } else {
                this.laborId = 0;
                this.parentName = this.selectedNode.data.item.Title;
                this.laborType = "category";
              }

              if (node.isExpanded) {
                node.collapse();
              } else {
                node.expand();
              }
              // this.laborDetail.resetData();
            } else {
              node.setIsActive(true);
              this.selectedNode = node;
              this.isDisplayedDetail = false;
              // load neededpart if click on Terminal
              if (this.selectedNode.data.item.Type == "Terminal") {
                this.laborId = 0;
                this.laborType = "terminal";
                this.parentName = this.selectedNode.data.item.Title;
              } else {
                this.laborId = 0;
                this.parentName = this.selectedNode.data.item.Title;
                // if (this.selectedNode.data.item.ParentId > 0) {
                //   this.laborType = "sub";
                // } else {
                //   this.laborType = "main";
                // }
              }

              if (node.isExpanded) {
                node.collapse();
              } else {
                node.expand();
              }
            }
          });
        } else {
          if (
            this.selectedCopiedTerminal.length > 0 &&
            node.data.item.ParentId > 0
          ) {
            let dialogRef = this.dialog.open(CopyComponent, {
              disableClose: true,
              width: "50%",
              height: "40%",
              data: {
                category: node.data.item.Title,
              },
            });

            dialogRef.afterClosed().subscribe((data) => {
              if (data.type == "no") {
                console.log("active");
                node.setIsActive(true);
                this.selectedNode = node;
                this.isDisplayedDetail = false;
                // load neededpart if click on Terminal
                if (this.selectedNode.data.item.Type == "Terminal") {
                  this.laborId = 0;
                  this.laborType = "terminal";
                  this.parentName = this.selectedNode.data.item.Title;
                } else {
                  this.laborId = 0;
                  this.parentName = this.selectedNode.data.item.Title;
                  this.laborType = "category";
                }

                this.edit();
                if (node.isExpanded) {
                  node.collapse();
                } else {
                  node.expand();
                }
              } else {
                this.isLoading = true;
                this.laborService
                  .copy(
                    this.selectedCopiedTerminal,
                    node.data.item.LaborGuideId
                  )
                  .subscribe((terminals) => {
                    if (node.data.children == undefined) {
                      node.data.children = [];
                    }
                    for (var i = 0; i < terminals.length; i++) {
                      node.data.children.push({
                        name: terminals[i].Title,
                        id: terminals[i].AddonId,
                        item: terminals[i],
                      });
                    }
                    this.tree.treeModel.update();
                    this.isLoading = false;
                    this.selectedCopiedTerminal = [];
                  });
              }
            });
          } else {
            node.setIsActive(true);
            this.selectedNode = node;
            this.isDisplayedDetail = false;
            // load neededpart if click on Terminal
            if (this.selectedNode.data.item.Type == "Terminal") {
              this.laborId = 0;
              this.laborType = "terminal";
              this.parentName = this.selectedNode.data.item.Title;
            } else {
              this.laborId = 0;
              this.parentName = this.selectedNode.data.item.Title;
              this.laborType = "category";
            }

            this.edit();
            if (node.isExpanded) {
              node.collapse();
            } else {
              node.expand();
            }
          }
        }
        /*
        } else {
          let isExist = this.isExistAddon(node.data.name);
          if (node.data.item.Type != 'Terminal') {
            alert('You only add Addon Terminal.');
          }
          else if (node.data.item.LaborGuideId == this.selectedNode.data.item.ParentId) {
            alert('You can not add parent.');
          }
          else if (!isExist) {
            this.confirmAddon(node);
          } else {
            alert('You already have this addon.');
          }
        }
        */
      },
    },
  };

  selectedLaborGuideId = 0;

  constructor(
    private laborService: LaborService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    var isLogin = localStorage.getItem("isLogin");
    if (isLogin != "true" || isLogin == null) {
      this.router.navigate(["/login"]);
    } else {
      this.isAdmin = localStorage.getItem("isAdmin") == "true";
    }
  }

  clearCopied(): void {
    this.selectedCopiedTerminal = [];
  }

  openCopy(): string {
    let dialogRef = this.dialog.open(CopyComponent, {
      disableClose: true,
      width: "60%",
      height: "40%",
    });

    let type = "";
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      type = result;
    });

    return type;
  }

  ngAfterViewInit() {
    // this.tree.treeModel.subscribeToState((state: any) => { // ITreeState does not contain selectedLeafNodeIds
    //   console.log(state);
    //   console.log(this.tree.treeModel.selectedLeafNodeIds);
    //   // drop the unwanted prototypes
    //   const selected = Object.assign({}, this.tree.treeModel.selectedLeafNodeIds);
    //   console.log(selected);
    // });
  }

  ngOnInit() {
    this.getLabors();
    this.activatedRoute.queryParams.subscribe((params) => {
      let vinNumber = params["vinNumber"];
      this.vinNumber = vinNumber != undefined ? vinNumber : "1FDEE14N7NHA53883";
    });
  }

  displayFn(qty: number) {
    return qty;
  }

  isExistAddon(name) {
    let childrens = this.selectedNode.data.children;
    if (childrens == null) {
      return false;
    } else {
      let childIndex = childrens.filter((a) => a.name == name);
      return childIndex.length > 0;
    }
  }

  isAvailableDelete() {
    return (
      this.selectedNode != null &&
      (this.selectedNode.data.item.Type == "Terminal" ||
        !this.selectedNode.hasChildren)
    );
  }

  isAddon() {
    let isAddon = false;

    if (
      this.selectedNode == null ||
      this.selectedNode.data.item.Type == "Addon"
    ) {
      isAddon = true;
    }
    return isAddon;
  }

  isCategory() {
    let isDisabled = true;

    if (
      this.selectedNode != null &&
      this.selectedNode.data.item.Type == "Category"
    ) {
      isDisabled = false;
    }
    return isDisabled;
  }

  isTerminal() {
    let isDisabled = true;

    if (
      this.selectedNode != null &&
      this.selectedNode.data.item.Type == "Terminal"
    ) {
      isDisabled = false;
    }
    return isDisabled;
  }

  onMoveNode($event) {
    let parent = $event.to.parent;
    if (parent.virtual) {
      alert("Please select Category.");
    } else {
      this.isLoading = true;
      let laborGuideItem = $event.node.item;
      let newParentId = $event.to.parent.item.LaborGuideId;
      this.laborService
        .changeCategory(laborGuideItem, newParentId)
        .subscribe(() => {
          this.isLoading = false;
        });
    }
  }

  options: ITreeOptions = {
    allowDrag: (node) => {
      return node.data.item.Type == "Terminal";
    },
    allowDrop: (element, { parent }) => {
      // return true / false based on element, to.parent, to.index. e.g.
      return (
        parent.data != undefined &&
        parent.data.item != undefined &&
        parent.data.item.Type != "Terminal"
      );
    },
    actionMapping: this.actionMapping,
  };

  confirmAddon(selectedAddon: any) {
    if (window.confirm("Are sure you want to add this Addon ?")) {
      let laborIds =
        this.selectedNode.data.item.LaborGuideId +
        "," +
        selectedAddon.data.item.LaborGuideId;
      this.laborService.addAddon(laborIds).subscribe((newAddonId) => {
        let newAddonData = {
          id: newAddonId,
          name: selectedAddon.data.name,
          item: {
            AddonId: newAddonId,
            Type: "Addon",
          },
        };
        // check if children is empty
        if (this.selectedNode.data.children == undefined) {
          this.selectedNode.data.children = [];
        }
        this.selectedNode.data.children.push(newAddonData);
        this.tree.treeModel.update();
        this.isAddonMode = false;
      });
    }
  }

  saveNeededPart() {
    this.neededPartItems = this.neededPartItems.filter((ele) => {
      return ele.Name != "";
    });

    this.neededPartItems.forEach((n) => {
      if (n.QuantityValue == "Specification") {
        n.Quantity = 0;
        n.SpecificationQuantity = true;
      } else {
        n.Quantity = parseFloat(n.QuantityValue);
        n.SpecificationQuantity = false;
      }
    });

    if (this.neededPartItems.length > 0) {
      this.isLoading = true;
      this.laborService.updateNeededPart(this.neededPartItems).subscribe(() => {
        this.isLoading = false;
      });
    }
  }

  filterNeededParts() {
    return this.neededPartItems.filter((n) => !n.IsDelete);
  }

  addNewItem(index = 0) {
    if (index == this.neededPartItems.length) {
      let newItem: NeededPartItem = {
        NeededPartId: 0,
        Name: "",
        Location: "",
        Quantity: 0,
        SpecificationQuantity: false,
        IsDelete: false,
        PartType: 0,
        PartTypeName: "Part",
        QuantityValue: "",
        IsSearchTerm : false
      };
      this.neededPartItems.push(newItem);
    }
  }

  addNew($event): void {
    let labor = $event;
    if (labor.ParentId == 0) {
      this.nodes.push({
        name: labor.Title,
        id: labor.AddonId,
        item: labor,
      });
      this.tree.treeModel.update();
    } else if (this.selectedNode != null) {
      //check if not have children yet
      if (this.selectedNode.data.children == undefined) {
        this.selectedNode.data.children = [];
      }
      this.selectedNode.data.children.push({
        name: labor.Title,
        id: labor.AddonId,
        item: labor,
      });
    }
    this.tree.treeModel.update();
    this.isDisplayedDetail = false;
  }

  oldParentId = 0;
  edit(): void {
    this.oldParentId =
      this.selectedNode != null ? this.selectedNode.data.item.ParentId : 0;
    this.action = "edit";
    this.laborId = this.selectedNode.data.item.AddonId;
    this.isDisplayedDetail = true;
    this.parentName = this.selectedNode.data.item.ParentName;
    if (this.selectedNode.data.item.Type == "Category") {
      if (this.oldParentId == 0) {
        this.laborType = "main";
      } else {
        this.laborType = "sub";
      }
    }
  }

  update($event): void {
    let labor = $event;
    let currentNode = {};
    if (this.oldParentId != labor.ParentId) {
      this.nodes.forEach((element) => {
        //remove in old node
        let parentNode = this.findNode(element, this.oldParentId);
        if (parentNode != undefined) {
          for (var i = 0; i < parentNode.children.length; i++) {
            if (
              parentNode.children[i].item.LaborGuideId == labor.LaborGuideId
            ) {
              parentNode.children.splice(i, 1);
            }
          }
        }
        //add in new node
        let parent = this.findNode(element, labor.ParentId);
        if (parent != undefined) {
          if (parent.children == undefined) {
            parent.children = [];
          }
          parent.children.push({
            name: labor.Title,
            id: labor.AddonId,
            item: labor,
          });
        }
      });
      this.oldParentId = 0;
    } else {
      this.nodes.forEach((element) => {
        let item = this.findNode(element, labor.LaborGuideId);
        if (item != undefined) {
          currentNode = item;
          currentNode["name"] = labor.Title;
        }
      });
    }

    this.tree.treeModel.update();
    this.isDisplayedDetail = false;
  }

  delete(): void {
    this.isLoading = true;
    let laborItem = this.selectedNode.data.item;
    if (laborItem.type == "Addon") {
      this.laborService.deleteAddon(laborItem.id).subscribe(() => {
        let index = this.selectedNode.parent.data.children.indexOf(
          this.selectedNode.data
        );
        this.selectedNode.parent.data.children.splice(index, 1);

        this.selectedNode = null; //set null for select node
        this.neededPartItems = []; //reset needed part list

        this.tree.treeModel.update();
        this.isLoading = false;
      });
    } else {
      this.laborService.deleteLabor(laborItem.LaborGuideId).subscribe(() => {
        let index = this.selectedNode.parent.data.children.indexOf(
          this.selectedNode.data
        );
        this.selectedNode.parent.data.children.splice(index, 1);

        this.selectedNode = null; //set null for select node
        this.neededPartItems = []; //reset needed part list

        this.tree.treeModel.update();
        this.isLoading = false;
      });
    }
  }

  openDialog(mode): void {
    let oldParentId =
      this.selectedNode != null ? this.selectedNode.data.item.ParentId : null;
    let dialogRef = this.dialog.open(LabordialogComponent, {
      disableClose: true,
      width: "60%",
      // height:'90%',
      data: {
        mode: mode,
        labors: this.rootLevel,
        allLabors: this.cats,
        selectedLabor:
          this.selectedNode != null ? this.selectedNode.data.item : null,
        currentVinNumber: this.vinNumber,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result != "") {
        let laborItem = result.laborItem;
        // let neededParts = result.neededParts;
        if (mode == "edit") {
          if (oldParentId != laborItem.ParentId) {
            this.nodes.forEach((element) => {
              //remove in old node
              let parentNode = this.findNode(element, oldParentId);
              if (parentNode != undefined) {
                for (var i = 0; i < parentNode.children.length; i++) {
                  if (
                    parentNode.children[i].item.LaborGuideId ==
                    laborItem.LaborGuideId
                  ) {
                    parentNode.children.splice(i, 1);
                  }
                }
              }
              //add in new node
              let parent = this.findNode(element, laborItem.ParentId);
              if (parent != undefined) {
                parent.children.push({
                  name: laborItem.Title,
                  id: laborItem.AddonId,
                  item: laborItem,
                });
              }
            });
          } else {
            this.nodes.forEach((element) => {
              let item = this.findNode(element, laborItem.LaborGuideId);
              if (item != undefined) {
                item["name"] = laborItem.Title;
              }
            });

            // this.neededPartItems = neededParts;
          }
          this.tree.treeModel.update();
        } else if (mode == "addSubLabor" || mode == "addTerminal") {
          if (this.selectedNode.data.children == undefined) {
            this.selectedNode.data.children = [];
          }
          this.nodes.forEach((element) => {
            //add in new node
            let parent = this.findNode(element, laborItem.ParentId);
            if (parent != undefined) {
              parent.children.push({
                name: laborItem.Title,
                id: laborItem.AddonId,
                item: laborItem,
              });
            }
          });
          this.tree.treeModel.update();
        } else {
          this.nodes.push({
            name: laborItem.Title,
            id: laborItem.AddonId,
            item: laborItem,
          });
          this.tree.treeModel.update();
        }
      }
    });
  }

  loadNeededParts(laborGuideId): void {
    this.selectedLaborGuideId = laborGuideId;
    this.getNeededParts(laborGuideId);
  }

  getChildren(labors, parentId) {
    let childrens = [];
    labors.forEach((l) => {
      if (l.ParentId == parentId) {
        let laborItem = {};
        laborItem["name"] = l.Title;
        laborItem["id"] = l.LaborGuideId;
        laborItem["item"] = l;
        childrens.push(laborItem);
      }
    });
    return childrens;
  }

  findNode(currentNode, id) {
    var i, currentChild, result;

    if (id == currentNode.item.LaborGuideId) {
      return currentNode;
    } else if (currentNode.children) {
      for (i = 0; i < currentNode.children.length; i += 1) {
        currentChild = currentNode.children[i];

        // Search in the current child
        result = this.findNode(currentChild, id);

        // Return the result if the node has been found
        if (result != undefined) {
          return result;
        }
      }

      // The node has not been found and we have no more options
      return null;
    }
  }

  returnAddonNameById(addonId: any, labors: any) {
    let addon = labors.filter((a) => a.LaborGuideId == addonId);
    if (addon != null && addon.length > 0) {
      return addon[0].Title;
    }
    return null;
  }

  getNestedChildren(labors: any, parentId: any): any {
    var out = [];
    for (var i in labors) {
      if (labors[i].ParentId == parentId) {
        let laborItem = { id: "", name: "" };
        laborItem.name = labors[i].Title;
        laborItem.id = labors[i].AddonId.toString();
        laborItem["item"] = labors[i];

        // no check children for addon
        if (labors[i].Type != "Addon") {
          var children = this.getNestedChildren(labors, labors[i].LaborGuideId);

          if (children.length) {
            laborItem["children"] = children;
          }
        }
        out.push(laborItem);
      }
    }

    return out;
  }

  verifiedLabor($event): void {
    let lgId = $event;
    this.nodes.forEach((element) => {
      let item = this.findNode(element, lgId);
      if (item != undefined) {
        item["item"]["IsVerified"] = 1;
      }
    });

    this.tree.treeModel.filterNodes((node) => {
      return !node.data.item.IsVerified;
    });

    this.unverifiedLaborQty--;
    this.isDisplayedDetail = false;
  }

  showUnverifiedLabors(): void {
    this.tree.treeModel.filterNodes((node) => {
      if (!node.data.item.IsVerified) {
        console.log(node);
      }
      return !node.data.item.IsVerified;
    });
    // if (this.unVerifiedLabors.length > 0) {
    //   if (this.unVerifiedLabors.length > 0) {
    //     let dialogRef = this.dialog.open(UnverifiedLaborComponent, {
    //       disableClose: true,
    //       width: '60%',
    //       height: '80%',
    //       data: {
    //         unverifiedLabors: this.unVerifiedLabors
    //       }
    //     });
    //   }
    // }
  }

  getAllData(): void {
    this.laborService.getAllDataCategories(this.vinNumber).subscribe(() => {
      // console.log(data);
    });
  }

  addCat(type: string): void {
    this.isDisplayedDetail = true;
    this.action = "addCategory";
    this.laborId =
      this.selectedNode != null ? this.selectedNode.data.item.LaborGuideId : 0;
    this.parentName =
      this.selectedNode != null ? this.selectedNode.data.item.Title : "";
    this.laborType = type;
  }

  addTerminal(): void {
    this.isDisplayedDetail = true;
    this.action = "addTerminal";
    this.laborId = this.selectedNode.data.item.LaborGuideId;
    // this.parentName = this.selectedNode.data.item.Title;
  }

  getLabors(): void {
    this.isLoading = true;

    this.laborService.getLabors().subscribe((labors) => {
      labors.sort(function (a, b) {
        if (a.Title < b.Title) return -1;
        if (a.Title > b.Title) return 1;
        return 0;
      });

      this.cats = labors.filter(
        (l) => l["Type"] != "Terminal" && l["Type"] != "Addon"
      );
      //filter unverified labor added by user
      this.unverifiedLaborQty = labors.filter(
        (l) => l["IsVerified"] == 0
      ).length;

      for (let index = 0; index < labors.length; index++) {
        const element = labors[index];
        if (element["IsVerified"] == 0) {
          
        }
      }
      this.rootLevel = labors.filter((lb) => lb["Type"] != "Terminal");
      this.nodes = this.getNestedChildren(labors, 0);
      this.isLoading = false;
    });
  }

  getCategories(): void {
    this.laborService.getCategories().subscribe(() => {});
  }

  getNeededParts(laborId: any): void {
    this.isLoading = true;
    this.laborService.getNeededParts(laborId).subscribe((neededParts) => {
      for (var i = 0; i < neededParts.length; i++) {
        if (neededParts[i].Quantity == 0) {
          neededParts[i].QuantityValue = "Specification";
        } else {
          neededParts[i].QuantityValue = neededParts[i].Quantity.toString();
        }
      }
      this.neededPartItems = neededParts;
      this.isLoading = false;
    });
  }

  copy(parentId: any): LaborGuideItem[] {
    this.isLoading = true;
    let terminals: LaborGuideItem[] = [];
    this.laborService
      .copy(this.selectedCopiedTerminal, parentId)
      .subscribe((result) => {
        terminals = result;
        this.isLoading = false;
      });
    return terminals;
  }

  openLaborTime(): void {
    let laborGuide = this.selectedNode.data.item;
    let dialogRef = this.dialog.open(LaborsearchComponent, {
      disableClose: true,
      width: "80%",
      height: "80%",
      data: {
        laborTimePath: "Labor Time Path",
        currentVinNumber: this.vinNumber,
        prodemandPath: this.selectedNode.data.item.ProdemandPath,
        allDataPath: this.selectedNode.data.item.AllDataPath,
        laborGuide: laborGuide,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.action == "save") {
        // console.log(result);
        let pathData = {
          allData: result.allDataPath,
          prodemand:
            result.prodemandPath == "" ? "NoData" : result.prodemandPath,
        };

        this.laborService
          .saveAppData(
            result.selectedParts,
            laborGuide,
            pathData,
            result.vehicleInfo
          )
          .subscribe((resp) => {
            console.log(resp);
            // this.selectedNode.data.item.ProdemandPath = result.prodemandPath;
            // this.selectedNode.data.item.AllDataPath = result.allDataPath;
          });
      }
    });
  }
}
